import React, { useState } from 'react'




export default function Textforms(props) {
    
    const handleOnClick=()=>{
        console.log("Text is being labelized⏳"+text)
        // let newText=text.funtion();
        // setText(newText);
        setText("Text is being labelled⏳")
        props.showAlert("Text is being labelled⏳", "success")
    }
    const handleExtraSpaces = () => {
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "))
        props.showAlert("Removed Extra Spaces✔", "success")
        }
    const handleCopy=()=>{
        props.showAlert("Text has been copied to your clipboard✔", "success")
        var text = document.getElementById("mybocs")
        text.select()
        navigator.clipboard.writeText(text.value)
        }
    const handleOnChange=(event)=>{
        console.log("On change⏳");
        setText(event.target.value);

    }
    const [text, setText] = useState('Start Typing or Paste here👀');
  
    return (
        <div>
            {/* <h3>{props.heading}</h3> */}
        {/* <div className="mb-3">
            <label for="exampleFormControlInput1" className="form-label">Email address</label>
            <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="name@example.com"/>
        </div> */}
        <div className="mb-3" style={{color: props.mode=== 'dark'?'white':'#042743'}}>
            <label for="mybocs" className="form-label"><h3>{props.heading}</h3></label>
            <textarea className="form-control" value = {text} onChange={handleOnChange} style={{backgroundcolour: props.mode==='dark'? '#042743': 'white',color: props.mode=== 'dark'?'#042743':'black'}} id="mybocs" rows="17" ></textarea>
            
        </div>
        <button className="btn btn-primary mx-1" onClick={handleOnClick}>Labelize!</button>
        <button className= "btn btn-primary mx-1" onClick={handleCopy}> Copy Text</button>
        <button className= "btn btn-primary mx-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>

        
        <div className="container my-3" style={{color: props.mode=== 'dark'?'white':'#042743'}}>
            <h1>
                Data Summary :
            </h1>
            <p>Your data contains {text.length} total characters and {text.split(" ").length-1} total words</p>
            <h2>Data Preview :</h2>
            <p>{text.length>0?text: 'Enter something in the above textbox to preview it here'}</p>
        </div>
        </div>
            )
}
